import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useParams } from 'react-router-dom';

import { Row } from 'react-bootstrap';
import { BrandAssets } from './constants/BrandAssets';
import { StaticLabels } from './constants/StaticLabels';
import BrandHeader from './components/BrandHeader';
import Disclaimer from './components/Disclaimer';
import Form from './components/Form';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  const [brand, setBrand] = React.useState('FredericMalle');
  const [market, setMarket] = React.useState('US'); // Initialize market state
  const [envVars, setEnvVars] = React.useState({});

// Use useEffect hook to read the URL parameter and update the brand and market states
useEffect(() => {
  // Function to parse the URL and get the parameter value
  const getParamFromURL = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  };

  // Get the brand and market from the URL parameters
  const brandFromURL = getParamFromURL('brand');
  const marketFromURL = getParamFromURL('market');

  // Update the brand and market states with the values from the URL parameters
  if (brandFromURL) {
    setBrand(brandFromURL);
  }
  if (marketFromURL) {
    setMarket(marketFromURL);
  }

  fetch('/env')
      .then((response) => response.json())
      .then((data) => setEnvVars(data))
      .catch((error) => console.error('Error fetching env vars:', error));
}, []); // Dependency array is empty to run the effect only once when the component mounts

  return (
    <div className="App d-flex justify-content-center">
      <div className="App-body">
        <Row className="my-2">
          <BrandHeader
            brandInformation={BrandAssets[brand][market]}
          />
        </Row>
        <Row className="my-2">
          <Disclaimer
            disclaimer={StaticLabels[market]?.Disclaimer}
          />
        </Row>
        <Row className="my-2">
          <PrivacyPolicy
            privacyPolicyLabel={StaticLabels[market]?.PrivacyPolicyLabel}
            privacyPolicyLink={BrandAssets[brand][market]?.privacyPolicyLink}
          />
        </Row>
        <Row className="my-2">
          <Form
            emailInputLabel={StaticLabels[market]?.EmailInputLabel}
            submitButton={StaticLabels[market]?.SubmitButton}
            formSuccessLabel={StaticLabels[market]?.FormSuccessLabel}
            formErrorLabel={StaticLabels[market]?.FormErrorLabel}
            market={market}
            brand={brand}
            envVars={envVars}
          />
        </Row>
      </div>
    </div>
  );
}

export default App;
